import ImageCompare from "image-compare-viewer";
import {initExploreTabs} from '../components/exploreTabs';
import {initSignupForm} from '../components/signupForm';
import {initSmoothScroll} from '../components/smoothScroll';
import {initSocialShare} from '../components/socialShare';
import {initVideoPlayer} from '../components/videoPlayer';
import {initCarousels} from "../components/carousels";
import {updateLanguageSwitches, updateLanguageLinks} from "../components/languageSwitcher";
import 'waypoints/lib/noframework.waypoints.min';
import 'featherlight/release/featherlight.min';
import {initEventFilter} from "../components/eventFilter";
import {initResourceFilter} from "../components/resourceFilter";
import {eventFilterComponent, resourceFilterComponent} from "../components";

export default {
	init() {
		if (sessionStorage.getItem("language-select") === null) {
			$(".language-select").removeClass("d-none")
			$('.language-select').on('closed.bs.alert', function () {
				sessionStorage.setItem("language-select", "seen");
			})
		}

		$('.select2').select2({
			allowClear: false,
			minimumResultsForSearch: Infinity,
		});

		const beforeafters = document.querySelectorAll(".beforeafter");
		beforeafters.forEach((element) => {
			new ImageCompare(element).mount();
		});

		updateLanguageSwitches();
		updateLanguageLinks();

		if ($(eventFilterComponent).length > 0) {
			initEventFilter();
		}
		if ($(resourceFilterComponent).length) {
			initResourceFilter();
		}

		initExploreTabs();
		initSignupForm();
		initSmoothScroll();
		initSocialShare();
		initVideoPlayer();
		initCarousels();

		//mobile menu
		$('.navbar-nav > .menu-item-has-children > a').click(function (e) {
			if ($(window).width() < 992) {
				e.preventDefault();
				$(this).siblings('.secondary-menu').addClass('secondary-menu--active');
			}
		});
		$('.secondary-menu__back').click(function () {
			$(this).parents('.secondary-menu').removeClass('secondary-menu--active');
		});

		const observerOptions = {
			rootMargin: '100px 0px',
			threshold: [0.25, 0, 0.25, 0],
		};
		//add active section when scroll into view
		const sections = document.querySelectorAll('.section');
		let sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					entry.target.classList.add('section--active');
				}
				// else {
				//   entry.target.classList.remove('section--active')
				// }
			});
		}, observerOptions);
		// Iterate over each queried el, and add observer:
		sections.forEach((section) => {
			sectionObserver.observe(section);
		});

		const counters = document.querySelectorAll('.counter');
		let counterObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					let $counter = $(entry.target);
					$counter.prop('Counter', 0).animate([
						{
							Counter: $counter.text(),
						},
						{
							duration: 1000,
							easing: 'swing',
							step: function (now) {
								$counter.text(Math.ceil(now));
							},
						},
					]);
				}
			});
		}, observerOptions);
		// Iterate over each queried el, and add observer:
		counters.forEach((counter) => {
			counterObserver.observe(counter);
		});

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};






// WEBPACK FOOTER //
// ./scripts/routes/common.ts